import React from 'react';
import {useIntl} from 'react-intl';

import {IReturnStatusBarProps} from './IReturnStatusBar';
import messages from './messages';
import {ReturnStatusBarItem} from './Subcomponents';

import styles from './ReturnStatusBar.module.scss';

const ReturnStatusBar = ({currentStep}: IReturnStatusBarProps) => {
	const intl = useIntl();

	return (
		<div className={styles['return-status-bar_wrapper']}>
			<ReturnStatusBarItem
				currentStep={currentStep}
				barItemReturnStep={0}
				barItemReturnStatusLabel={intl.formatMessage(messages.returnStatusSelect)}
			/>
			<ReturnStatusBarItem
				currentStep={currentStep}
				barItemReturnStep={1}
				barItemReturnStatusLabel={intl.formatMessage(messages.returnStatusView)}
			/>
		</div>
	);
};

export default ReturnStatusBar;
